module.exports = __webpack_public_path__ + "img/instagram.0f859278.svg";